import React from "react"
import {AppNotice} from "@app-core/AppNotice"

export const AboutView: React.FC = () => {
  return <AppNotice notice="About Page Coming Soon" />
}

export default AboutView
